/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "sJPBuUDGqGg",
    title: "10 Amazing Badminton Trickshots",
    description:
      "10 amazing badminton trickshots, learn them here, some very cool badminton trick shots for you to learn. These 10 trickshots are all made by World Champion Thomas Laybourn, some of them for fun, but also some you can use in a match😉",
    creator: "Badminton Famly",
    duration: "08:25",
    views: "1.6M",
    uploaded: "1",
    categoryName: "Tricks",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "S2-G_tbIj80",
    title: "12 Basic Badminton Techniques ",
    description:
      "This video is meant to be a quick intro to the different techniques and the jargon. For in-depth guides on each skill, search them up on Shuttle Tube, the names of them are 👆",
    creator: "Badminton Academy",
    duration: "06:37",
    views: "3.6M",
    uploaded: "2",
    categoryName: "Tricks",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "DnUwBz2BVYM",
    title: "Common Beginner Badminton Mistakes",
    description:
      "badminton dos and don'ts video, this time we are taking a look at the most common beginner badminton mistakes we see. We show you what some common mistakes we see are along with how and why to correct these.",
    creator: "Jacobs Badminton",
    duration: "04:39",
    views: "3.9M",
    uploaded: "2",
    categoryName: "Mistakes",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "J3qLwJEQ15c",
    title: "TOP 10 BADMINTON TRICK SHOTS",
    description:
      "What a Badminton year 2020 have been! So many things have happened but sadly the Corona virus turned out to hit us very hard, and the world was simply not ready. ",
    creator: "Shuttle Life",
    duration: "07:05",
    views: "5.9M",
    uploaded: "5",
    categoryName: "Tricks",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "qYvEuwrSiXc",
    title: "TOP 10 BADMINTON TRICK SHOTS",
    description:
      "TOP 10 TRICK SHOT, FROM OUR CHANNEL!",
    creator: "Shuttle Life",
    duration: "07:10",
    views: "2.3M",
    uploaded: "8",
    categoryName: "Tricks",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "kRkVO964Djc",
    title: "How to Smash",
    description:
      "if you are a Beginner or Intermediate Player and you are getting problems while Hitting Smash or you are not able to generate Power in your Smash, so in this video, I am going to tell you HOW TO HIT HARD SMASH from Beginners Level to Advance Level with Proper Technique and some Exercise yo improve your Power for Hard Smash.",
    creator: "Hi-Tech Badminton",
    duration: "07:55",
    views: "1.1M",
    uploaded: "6",
    categoryName: "Smash",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "H7kpZ9inc10",
    title: "Badminton SMASH Tutorial",
    description:
      "A detailed breakdown of the badminton smash including tips to help you improve your power, consistency and accuracy.",
    creator: "Badminton Insight",
    duration: "10:55",
    views: "9.7M",
    uploaded: "10",
    categoryName: "Smash",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "j1ZtoPc72Mo",
    title: "Defense against the Smash",
    description:
      "This comprehensive video features instruction from expert player and coach Andy Chong. Andy provides numerous tips and techniques that will help give you an edge over the competition.",
    creator: "Sport Videos",
    duration: "04:22",
    views: "8.4M",
    uploaded: "3",
    categoryName: "Smash",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "07x6-qippgo",
    title: "How to use the wrist in badminton",
    description:
      "How to use the wrist in badminton - 5 shots biomechanics. I will show you how not to use the wrist, and also how to use it correctly. In badminton the wrist biomechanics is really important to get more power in your shots, and to avoid injuries in the wrist. With the correct badminton grip, it is easier to learn the right technique, and to use the wrist the right way, with forearm rotation. ",
    creator: "Badminton Famly",
    duration: "12:10",
    views: "11.7M",
    uploaded: "11",
    categoryName: "Smash",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
  {
    _id: "Px5XUqcvyXc",
    title: "TIPS TO IMPROVE YOUR SMASH!",
    description:
      "Today we are going to look at the overhead power smash. Hope you will find this smash guide tutorial useful! ",
    creator: "Victor Axslen Insight",
    duration: "04:13",
    views: "5.7M",
    uploaded: "1",
    categoryName: "Smash",
    logo: "https://yt3.ggpht.com/ytc/AKedOLQBVrfvqOj3RH4BXQs2PzBW0gTSYygAGwSbnRXD0g=s176-c-k-c0x00ffffff-no-rj-mo",
  },
];
